module.exports = "<div class=\"tableize\">\n\t<input type=\"{{to.type||'text'}}\" class=\"c-input\" ng-model=\"model[options.key]\" />\n\t<span class=\"c-text c-text--normal c-text--faded u-pl--\">{{to.currency}}</span>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/formly/money.html
 ** module id = 541
 ** module chunks = 0
 **/